import React, { useCallback, useEffect, useRef, useState } from "react";
import { ChildrenProps } from "../models/componentModel";
import {
  CommonResponseModel,
  CommonResponseSecondaryModel,
  CustomerDetailModel,
  LoaderDetailsResponseModel,
  LoginPayloadModel,
  RegisterDataResponseModel,
  RegisterPayloadModel,
  SendLoginOTPPayloadModel,
  SendOTPResponseDataModel,
  UserMeResponseDataModel,
  VerifyAccountOTPPayloadModel,
  apiRoutesPermissionAssignmentsDataModel,
  chronoxUserRolesDataModel,
  customerSubscriptionDetailsModel,
  errorModel,
  getCustomPagesResponseModel,
  getOrganizationDetailDataModel,
  languageListObj,
  loaderFilterdetails,
  loaderProps,
  loginWithPasswordPayload,
  organizationRoleInterface,
  promptLogFieldObjModel,
  stripeCurrencyTypeObjModel,
  userAssignmentRoleDataModel,
  vendorDataResponse,
} from "../models/axiosModel";
import agent from "../services/api";
import { abortInFlightApiRequests, hasInFlightApiRequests, onApiRequestSettled } from "../services/apiRequestLifecycle";
import { checkForErrorCode, flagCookieExpired, getErrorMessage, ifUserMessageShouldBeDynamic, isDev, usePublicMenuItems } from "../utils/constants";
import { useNavigate } from "react-router-dom";
import { validateAndRefreshFCMToken } from "../services/fcmService";
import { useGenericStore } from "../store/genericStore";

const UserContext = React.createContext<UserContextPayload | undefined>(
  undefined
);

export interface UserContextPayload {
  flagLoading: loaderProps;
  setFlagLoading: React.Dispatch<React.SetStateAction<loaderProps>>;
  resetLoadingOnRouteChange: (flagKeepRequests?: boolean) => void;
  userDetail: UserMeResponseDataModel;
  setUserDetail: React.Dispatch<React.SetStateAction<UserMeResponseDataModel>>;
  UserMe: () => Promise<CommonResponseModel<RegisterDataResponseModel>>;
  Register: (payload: RegisterPayloadModel) => Promise<CommonResponseModel<RegisterDataResponseModel> | CommonResponseSecondaryModel<SendOTPResponseDataModel>>;
  SendAccountOTP: () => Promise<CommonResponseSecondaryModel<SendOTPResponseDataModel>>;
  OneTapLoginAuthCallback: (payload: any) => Promise<any>;
  VerifyAccount: (payload: VerifyAccountOTPPayloadModel) => Promise<CommonResponseSecondaryModel<{}>>;
  SendLoginOTP: (payload: SendLoginOTPPayloadModel) => Promise<CommonResponseSecondaryModel<SendOTPResponseDataModel>>;
  Login: (payload: LoginPayloadModel) => Promise<CommonResponseModel<RegisterDataResponseModel>>;
  loginWithPassword: (payload: loginWithPasswordPayload) => Promise<CommonResponseModel<any>>;
  customerDetail: CustomerDetailModel;
  setCustomerDetail: React.Dispatch<React.SetStateAction<CustomerDetailModel>>;
  GetCustomerDetails: () => Promise<any>;
  UpdateCustomerDetails: (payload: CustomerDetailModel) => Promise<any>;
  customerSubscriptionDetails: null | customerSubscriptionDetailsModel,
  setCustomerSubscriptionDetails: React.Dispatch<React.SetStateAction<null | customerSubscriptionDetailsModel>>;
  GetCustomerSubscriptionDetails: () => Promise<any>;
  flagOnboardingSkip: boolean | null,
  setFlagOnboardingSkip: React.Dispatch<React.SetStateAction<boolean | null>>;
  languageList: languageListObj[];
  setLanguageList: React.Dispatch<React.SetStateAction<languageListObj[]>>
  getLanguagesList: () => void;
  flagChromeDesktop: boolean | null;
  setFlagChromeDesktop: React.Dispatch<React.SetStateAction<null | boolean>>
  setStripeCurrencyTypeGenericList: React.Dispatch<React.SetStateAction<stripeCurrencyTypeObjModel[]>>
  stripeCurrencyTypeGenericList: stripeCurrencyTypeObjModel[]
  GetStripeCurrencyTypeGenericList: () => void;
  promptLogFieldGenericList: promptLogFieldObjModel[];
  setPromptLogFieldGenericList: React.Dispatch<React.SetStateAction<promptLogFieldObjModel[]>>
  GetPromptLogFieldGenericList: () => void;
  loadingURL: any;
  setLoadingURL: any
  flagShowCreditsExhausted: boolean;
  setFlagShowCreditsExhausted: React.Dispatch<React.SetStateAction<boolean>>;
  showLoginPopup: boolean;
  setShowLoginPopup: React.Dispatch<React.SetStateAction<boolean>>;
  getLoaderDetails: () => Promise<CommonResponseModel<LoaderDetailsResponseModel | null>>;
  setLoaderDetails: React.Dispatch<React.SetStateAction<LoaderDetailsResponseModel | null>>;
  loaderDetails: LoaderDetailsResponseModel | null;
  loaderFilterDetails: any;
  setLoaderFilterDetails: any;
  loaderFilterDataList: loaderFilterdetails,
  setLoaderFilterDataList: React.Dispatch<React.SetStateAction<loaderFilterdetails>>,
  setLoaderIndex: any,
  loaderIndex: any
  countryCode: string,
  setCountryCode: React.Dispatch<React.SetStateAction<string>>;
  flagShowScheduleCall: boolean,
  setFlagShowScheduleCall: React.Dispatch<React.SetStateAction<boolean>>;
  flagShowOnboardingEndPopup: boolean,
  setFlagOnboardingEndPopup: React.Dispatch<React.SetStateAction<boolean>>;
  sidePanelMenuItems: any;
  setSidePanelMenuItems: React.Dispatch<React.SetStateAction<any>>;
  openConsultationBar: boolean;
  setOpenConsultationBar: React.Dispatch<React.SetStateAction<boolean>>;
  handleOpenConsultationBar: () => void;
  handleCloseConsultationBar: () => void;
  flagHideConsultation: boolean,
  setFlagHideConsultation: React.Dispatch<React.SetStateAction<boolean>>;
  handleHideConsultation: () => void;
  GetOrganizationDetails: () => Promise<CommonResponseModel<getOrganizationDetailDataModel>>;
  organizationDetails: getOrganizationDetailDataModel[] | null;
  setOrganizationDetails: React.Dispatch<React.SetStateAction<getOrganizationDetailDataModel[] | null>>;
  resetOrganizationContext: () => void;
  GetCustomPages: () => void;
  customPagesData: getCustomPagesResponseModel[] | null;
  setCustomPagesData: React.Dispatch<React.SetStateAction<getCustomPagesResponseModel[] | null>>;
  currentActiveMenu: string;
  setCurrentActiveMenu: React.Dispatch<React.SetStateAction<string>>;
  currentActiveMobileMenu: string;
  setCurrentActiveMobileMenu: React.Dispatch<React.SetStateAction<string>>;
  selectedSubMenu: string[];
  setSelectedSubMenu: React.Dispatch<React.SetStateAction<string[]>>;
  currentMenuName: string;
  setCurrentMenuName: React.Dispatch<React.SetStateAction<string>>;
  webSocketObj: any,
  setWebSocketObj: any,
  handleError: (response: any) => void,
  vendorData: vendorDataResponse | null,
  setVendorData: React.Dispatch<React.SetStateAction<vendorDataResponse | null>>, 
  organizationRole: organizationRoleInterface[] | null, 
  setOrganizationRole: React.Dispatch<React.SetStateAction<organizationRoleInterface[] | null>>, 
  getOrganizationRoleApi: () => Promise<CommonResponseModel<organizationRoleInterface>>,
  onBoardUser: (user_id?: number) => Promise<void>,
  flagUpdateUserDetailPopup: boolean, 
  setFlagUpdateUserDetailPopup: React.Dispatch<React.SetStateAction<boolean>>, 
  flagViewUserDetailPopup: boolean, 
  setFlagViewUserDetailPopup: React.Dispatch<React.SetStateAction<boolean>>,
  generateFCMToken: () => Promise<void>,
  chronoxUserRolesData: chronoxUserRolesDataModel[] | null, 
  setChronoxUserRolesData: React.Dispatch<React.SetStateAction<chronoxUserRolesDataModel[] | null>>,
  getChronoxUserRoleApi: () => Promise<CommonResponseModel<chronoxUserRolesDataModel>>,
  userAssignmentRoleData: userAssignmentRoleDataModel[] | null, 
  setUserAssignmentRoleData: React.Dispatch<React.SetStateAction<userAssignmentRoleDataModel[] | null>>,
  getUserAssignmentRoleApi: () => Promise<CommonResponseModel<userAssignmentRoleDataModel>>,
  apiRoutesPermissionAssignment: apiRoutesPermissionAssignmentsDataModel[] | null, 
  setApiRoutesPermissionAssignment: React.Dispatch<React.SetStateAction<apiRoutesPermissionAssignmentsDataModel[] | null>>,
  getAPIRoutesPermissionAssignments: (chronox_user_role_id: string) => Promise<CommonResponseModel<apiRoutesPermissionAssignmentsDataModel>>,
  flagAddMemberPopup: boolean, 
  setFlagAddMemberPopup: React.Dispatch<React.SetStateAction<boolean>>,
  showOrganizationPausedAlert: boolean,
  setShowOrganizationPausedAlert: React.Dispatch<React.SetStateAction<boolean>>,
}

const UserProvider = ({ children }: ChildrenProps) => {
  const [flagLoading, setFlagLoadingState] = useState<loaderProps>({
    flagRoundLoader: false,
    flagContentGenerating: false
  });
  
  // Pathname of the page that turned the loader on, so a route change clears only the previous page's loader
  const loaderPathnameRef = useRef(window.location.pathname);
  
  // Loader clear postponed until the current page's requests finish
  const flagPendingLoaderClearRef = useRef(false);

  const setFlagLoading = useCallback<React.Dispatch<React.SetStateAction<loaderProps>>>((update) => {
    const pathnameAtCall = window.location.pathname;
    setFlagLoadingState((prev) => {
      const next = typeof update === "function" ? update(prev) : update;
      if (next.flagRoundLoader) {
        loaderPathnameRef.current = pathnameAtCall;
        flagPendingLoaderClearRef.current = false;
        return next;
      }
      // Cleared while this page's requests are still loading (e.g. a request of the previous page under the same layout finishing late),
      // so keep the loader until they finish
      if (prev.flagRoundLoader && hasInFlightApiRequests(window.location.pathname)) {
        flagPendingLoaderClearRef.current = true;
        return { ...next, flagRoundLoader: true };
      }
      return next;
    });
  }, []);

  useEffect(() => onApiRequestSettled(() => {
    // Checked after the caller's continuation, which may start its next request
    setTimeout(() => {
      if (flagPendingLoaderClearRef.current && !hasInFlightApiRequests(window.location.pathname)) {
        flagPendingLoaderClearRef.current = false;
        setFlagLoadingState((prev) => ({ ...prev, flagRoundLoader: false }));
      }
    });
  }), []);

  const resetLoadingOnRouteChange = useCallback((flagKeepRequests: boolean = false) => {
    // Pages under the same nested layout keep their requests running (the layout's loads must complete)
    if (!flagKeepRequests) {
      abortInFlightApiRequests();
    }
    // The new page's layout effects run before this (child before parent), so keep a loader it already turned on
    setFlagLoadingState((prev) => loaderPathnameRef.current === window.location.pathname ? prev : { ...prev, flagRoundLoader: false });
  }, []);
  
  const [loadingURL, setLoadingURL] = useState("default");
  const [webSocketObj, setWebSocketObj] = useState<any>(null);
  
  const emptyUserDetail = {
    timezone_id: 0,
    timezone_name: "",
    timezone_hour: "",
    timezone_standard_name: "",
    flagUser: null,
    flag_user_anonymous: null,
    flag_email_verified: null,
    flag_onboarded: null,
    user_id: 0,
    user_type: "",
    user_first_name: "",
    user_last_name: "",
    user_email: "",
    user_assignment_id: 0,
    user_phone_number: "",
    user_status: {
      user_status_id: 0,
      user_status_name: ""
    },
    user_popup_actions: [],
    plan_detail: null,
    user_role: {
      user_role_id: 0,
      user_role_name: ""
    },
    user_organization_data: null, 
    access_token: null,
    user_assignment_role_data: null,
    user_organization_feature_disabled: [],
    flag_send_direct_canned_message: false,
    org_billing_plan_data: null,
    flag_password: false,
  };
  const emptyCustomerObj = {
    gc_stripe_customer_id: 0,
    stripe_customer_id: "",
    user_id: 0,
    company_id: 0,
    stripe_customer_first_name: "",
    stripe_customer_last_name: "",
    stripe_customer_email: "",
    stripe_customer_add1: "",
    stripe_customer_add2: "",
    stripe_customer_city: "",
    stripe_customer_state: "",
    stripe_customer_country: "",
    stripe_customer_postal_code: "",
    stripe_customer_phone: "",
    stripe_customer_flag_is_indian: true,
    stripe_customer_tax_id: "",
    created_at_timestamp: "",
    updated_at_timestamp: "",
  }

  const navigate = useNavigate();

  const [userDetail, setUserDetail] = useState<UserMeResponseDataModel>(emptyUserDetail);

  const [loaderDetails, setLoaderDetails] = useState<LoaderDetailsResponseModel | null>(null);
  const [loaderFilterDetails, setLoaderFilterDetails] = useState<loaderFilterdetails>({
    index: 0,
    loaderDetails: []
  });

  const [apiRoutesPermissionAssignment, setApiRoutesPermissionAssignment] = useState<apiRoutesPermissionAssignmentsDataModel[] | null>(null)

  const [loaderIndex, setLoaderIndex] = useState<any>(0);
  const [loaderFilterDataList, setLoaderFilterDataList] = useState<any>(null)
  const [customerDetail, setCustomerDetail] = useState<CustomerDetailModel>(emptyCustomerObj)
  const [customerSubscriptionDetails, setCustomerSubscriptionDetails] = useState<null | customerSubscriptionDetailsModel>(null)
  const [flagOnboardingSkip, setFlagOnboardingSkip] = useState<boolean | null>(null)
  const [languageList, setLanguageList] = useState<languageListObj[] | []>([])
  const [flagChromeDesktop, setFlagChromeDesktop] = useState<boolean | null>(null)
  const [stripeCurrencyTypeGenericList, setStripeCurrencyTypeGenericList] = useState<stripeCurrencyTypeObjModel[]>([])
  const [promptLogFieldGenericList, setPromptLogFieldGenericList] = useState<promptLogFieldObjModel[]>([])
  const [flagShowCreditsExhausted, setFlagShowCreditsExhausted] = useState(false)
  const [showLoginPopup, setShowLoginPopup] = useState(false)
  const [countryCode, setCountryCode] = useState("in");
  const [flagShowScheduleCall, setFlagShowScheduleCall] = useState(false);
  const [flagShowOnboardingEndPopup, setFlagOnboardingEndPopup] = useState(false);
  const [sidePanelMenuItems, setSidePanelMenuItems] = React.useState(usePublicMenuItems(userDetail, apiRoutesPermissionAssignment));
  const [openConsultationBar, setOpenConsultationBar] = useState(false)
  const [flagHideConsultation, setFlagHideConsultation] = useState(false)
  const [organizationDetails, setOrganizationDetails] = useState<getOrganizationDetailDataModel[] | null>(null)
  const [customPagesData, setCustomPagesData] = useState<getCustomPagesResponseModel[] | null>(null)
  const [currentActiveMenu, setCurrentActiveMenu] = React.useState("home");
  const [currentActiveMobileMenu, setCurrentActiveMobileMenu] = React.useState("home");
  const [selectedSubMenu, setSelectedSubMenu] = React.useState<string[]>([]);
  const [currentMenuName, setCurrentMenuName] = React.useState("");

  const [flagUpdateUserDetailPopup, setFlagUpdateUserDetailPopup] = useState<boolean>(false);
  const [flagViewUserDetailPopup, setFlagViewUserDetailPopup] = useState<boolean>(false);

  const [chronoxUserRolesData, setChronoxUserRolesData] = useState<chronoxUserRolesDataModel[] | null>(null)
  const [userAssignmentRoleData, setUserAssignmentRoleData] = useState<userAssignmentRoleDataModel[] | null>(null)

  const [vendorData, setVendorData] = useState<vendorDataResponse | null>(null) 

  const [organizationRole, setOrganizationRole] = useState<organizationRoleInterface[] | null>(null);

  const [flagAddMemberPopup, setFlagAddMemberPopup] = useState<boolean>(false);
  const [showOrganizationPausedAlert, setShowOrganizationPausedAlert] = useState(false);

  const UserMe = async () => {
    setFlagLoading({ ...flagLoading, flagRoundLoader: true });
    setLoadingURL(agent.UserMeAPI.getURL)
    const response = await agent.UserMeAPI.get();
    if (response.status) {
      setUserDetail(prevUserDetail => {
        const updatedUserDetail = {
          ...prevUserDetail,
          flagUser: response.status,
          ...response.data[0],
        };
        if (prevUserDetail.flagUserFromParaphrase) {
          updatedUserDetail.flagUserFromParaphrase = prevUserDetail.flagUserFromParaphrase;
        }
        return updatedUserDetail;
      });

      // Validate and refresh FCM token when user is logged in
      // This runs on page load/refresh when user is already authenticated
      if (response.data?.[0]?.access_token) {
        // Call FCM token validation asynchronously (don't block UserMe response)
        generateFCMToken().catch((error) => {
          console.error('[UserMe] FCM token validation failed:', error);
        });
      }
      const userAssignmentRoleData = response?.data?.[0]?.user_assignment_role_data?.[0];
      if(userAssignmentRoleData){
        const chronoxUserRoleId = userAssignmentRoleData?.chronox_user_role_id  
        await getAPIRoutesPermissionAssignments(chronoxUserRoleId);
      }

    } else {
      setUserDetail({ ...emptyUserDetail, flagUser: false });
    }
    setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    return response;
  };
  const getLanguagesList = async () => {
    const response = await agent.getLanguageList.get()
    if (response.status) {
      setLanguageList(response.data)
    } else {
      setLanguageList([])
    }
  }
  const Register = async (payload: RegisterPayloadModel): Promise<CommonResponseModel<RegisterDataResponseModel> | CommonResponseSecondaryModel<SendOTPResponseDataModel>> => {
    setFlagLoading({ ...flagLoading, flagRoundLoader: true });
    const response = await agent.RegisterAPI.post(payload);
    setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    return response;
  }
  const SendAccountOTP = async () => {
    const response = await agent.SendAccountOTPAPI.post();
    return response;
  };
  const OneTapLoginAuthCallback = async (payload: any) => {
    const response = await agent.oneTapLoginAuthCallback.post(payload);
    return response;
  };
  const VerifyAccount = async (payload: VerifyAccountOTPPayloadModel) => {
    const response = await agent.VerifyAccountOTPAPI.put(payload);
    return response;
  };
  const SendLoginOTP = async (payload: SendLoginOTPPayloadModel) => {
    const response = await agent.SendLoginOTPAPI.post(payload);
    return response;
  };
  const Login = async (payload: LoginPayloadModel) => {
    const response = await agent.VerifyLoginOTPAPI.put(payload);
    return response;
  };

  const loginWithPassword = async (payload: loginWithPasswordPayload) => {
    const response = await agent.loginWithPasswordAPI.post(payload);
    return response;
  }

  const GetCustomerDetails = async () => {
    const response = await agent.getCustomerDetail.get();
    if (response.status) {
      setCustomerDetail(response.data[0])
    } else {
      setCustomerDetail(emptyCustomerObj)
    }
    return response;
  };
  const UpdateCustomerDetails = async (payload: CustomerDetailModel) => {
    setFlagLoading({ ...flagLoading, flagRoundLoader: true });
    const response = await agent.updateCustomerDetail.put(payload);
    setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    if (response.status) {

      // setCustomerDetail(response.data[0])
      setCustomerDetail(payload)
      const { showSuccess } = useGenericStore.getState();
      showSuccess("Customer Details Updated Successfully!")
      // return true
    } else {
      const { showError } = useGenericStore.getState();
      showError(response.error.message)
      // return false
    }
    return response;
  }
  const GetPricingDetail = async () => {
    const response = await agent.getPricingDetail.get();
    return response;
  }
  const GetCustomerSubscriptionDetails = async () => {
    const response = await agent.getStripeCustomerSubscriptionDetail.get();
    if (response.status) {
      setCustomerSubscriptionDetails(response.data[0])
    }
    return response;
  }

  const GetStripeCurrencyTypeGenericList = async () => {
    const response = await agent.getStripeCurrencyTypeGenericList.get();
    if (response.status) {
      setStripeCurrencyTypeGenericList(response.data)
    } else {
    }
  }
  const GetPromptLogFieldGenericList = async () => {
    const response = await agent.getPromptLogFieldsGenericList.get();
    if (response.status) {
      setPromptLogFieldGenericList(response.data)
    } else {
    }
  }
  const handleOpenConsultationBar = () => {
    setOpenConsultationBar(true)
  }
  const handleCloseConsultationBar = () => {
    setOpenConsultationBar(false)
  }
  const handleHideConsultation = () => {
    setFlagHideConsultation(true)
  }
  const getLoaderDetails = async () => {
    const response = await agent.LoaderDetailsAPI.get();
    return response
  }

  const GetOrganizationDetails = async () => {
    const response = await agent.getOrganizationDetails.get();
    if (response.status) {
      setOrganizationDetails(response.data)
    }
    else {
      setOrganizationDetails(null)
    } 
    return response;
  }
  function resetOrganizationContext() {
    setOrganizationDetails(null)
  }

  const GetCustomPages = async () => {
    const response = await agent.getCustomPages.get();
    if (response.status) {
      setCustomPagesData(response.data)
    }
    else {
      setCustomPagesData(null)
    }
  } 

  const getOrganizationRoleApi = async () => {
    const res = await agent.getOrganizationUserRole.get();
    if(res.status){
      setOrganizationRole(res.data);
    } else { 
      setOrganizationRole(null);
    } 
    return res;
  }

  const handleError = (response: any) => {
    if(response?.flagAborted) return;

    const { showError } = useGenericStore.getState();
    
    if (response) {
      let errorCode = checkForErrorCode(response)
      if (flagCookieExpired(userDetail, errorCode)) {
        showError("Session expired! Please login to continue.");
        let url = encodeURIComponent(window.location.pathname + window.location.search)
        window.location.href = "/login?redirect=" + url;
      } else {
        if (ifUserMessageShouldBeDynamic(errorCode)) {
          showError(response.error.message || response.data.error.message);
        } else {
          showError(getErrorMessage(errorCode, isDev(userDetail), response));
        }
      }
    }
  } 

  const onBoardUser = async (user_id?: number) => { 
    if(!userDetail?.flag_onboarded || user_id){ 
      const private_user_id = user_id ?? userDetail?.user_id; 
      if(private_user_id){
        const payload = {
          private_user_id: private_user_id,
        }
    
        const res = await agent.onBoardingProcess.put(payload);
        if(res.status){
            if(!user_id){
              setUserDetail((prev) => ({
                  ...prev, 
                  flag_onboarded: true,
              }));
            }
        } else {
            handleError(res);
        }
      } else {
        console.warn("No valid user_id found. Skipping onboarding");
      }
    }
  }

  const generateFCMToken = async () => {
    try {
      console.log('[Login] Starting FCM token validation and refresh...');
      // Validate existing token or generate new one if invalid/missing
      const token = await validateAndRefreshFCMToken(vendorData);
      if (token) {
        console.log('[Login] FCM token validated/refreshed successfully');
      } else {
        console.warn('[Login] FCM token validation/refresh returned null - check console for details');
      }
    } catch (error: any) {
      // Log error but don't break login flow
      console.error('[Login] FCM token validation/refresh failed:', error);
      console.error('[Login] Error details:', error?.message, error?.stack);
    }
  }
  
  const getChronoxUserRoleApi = async () => {
    const res = await agent.getChronoxUserRolesGeneric.get();
    if(res.status){
      setChronoxUserRolesData(res.data);
    } else {
      setChronoxUserRolesData(null);
    }

    return res;
  }

  const getUserAssignmentRoleApi = async () => {
    const res = await agent.getUserAssignmentRoles.get();
    if(res.status){
      setUserAssignmentRoleData(res.data);
    } else {
      setUserAssignmentRoleData(null);
    }

    return res;
  }

  const getAPIRoutesPermissionAssignments = async (chronox_user_role_id: string) => {
    const res = await agent.getAPIRoutesPermissionAssignments.get(chronox_user_role_id);
    if(res.status){
      setApiRoutesPermissionAssignment(res.data);
    } else {
      setApiRoutesPermissionAssignment(null);
    }

    return res;
  }

  const payload = {
    flagLoading,
    setFlagLoading,
    resetLoadingOnRouteChange,
    userDetail,
    setUserDetail,
    UserMe,
    Register,
    SendAccountOTP,
    VerifyAccount,
    SendLoginOTP,
    Login,
    loginWithPassword,
    customerDetail,
    setCustomerDetail,
    GetCustomerDetails,
    GetPricingDetail,
    UpdateCustomerDetails,
    OneTapLoginAuthCallback,
    customerSubscriptionDetails,
    setCustomerSubscriptionDetails,
    GetCustomerSubscriptionDetails,
    flagOnboardingSkip,
    setFlagOnboardingSkip,
    languageList,
    setLanguageList,
    getLanguagesList,
    flagChromeDesktop,
    setFlagChromeDesktop,
    GetStripeCurrencyTypeGenericList,
    stripeCurrencyTypeGenericList,
    setStripeCurrencyTypeGenericList,
    GetPromptLogFieldGenericList,
    promptLogFieldGenericList,
    setPromptLogFieldGenericList,
    loadingURL,
    setLoadingURL,
    flagShowCreditsExhausted,
    setFlagShowCreditsExhausted,
    showLoginPopup,
    setShowLoginPopup,
    getLoaderDetails,
    loaderDetails,
    setLoaderDetails,

    loaderFilterDataList,
    setLoaderFilterDataList,

    loaderFilterDetails,
    setLoaderFilterDetails,

    setLoaderIndex,
    loaderIndex,
    countryCode,
    setCountryCode,
    flagShowScheduleCall,
    setFlagShowScheduleCall,
    flagShowOnboardingEndPopup,
    setFlagOnboardingEndPopup,
    sidePanelMenuItems, setSidePanelMenuItems,
    setOpenConsultationBar,
    openConsultationBar,
    handleOpenConsultationBar,
    handleCloseConsultationBar,
    flagHideConsultation,
    setFlagHideConsultation,
    handleHideConsultation,

    GetOrganizationDetails,
    organizationDetails,
    setOrganizationDetails,
    resetOrganizationContext,
    GetCustomPages,
    customPagesData,
    setCustomPagesData,
    currentActiveMenu,
    setCurrentActiveMenu,
    currentActiveMobileMenu,
    setCurrentActiveMobileMenu,
    selectedSubMenu,
    setSelectedSubMenu,
    currentMenuName,
    setCurrentMenuName,
    webSocketObj,
    setWebSocketObj,
    handleError,
    vendorData,
    setVendorData,
    onBoardUser,
    // loadingURL,
    // setLoadingURL, 
    organizationRole, 
    setOrganizationRole, 
    getOrganizationRoleApi, 
    flagUpdateUserDetailPopup, 
    setFlagUpdateUserDetailPopup,
    flagViewUserDetailPopup, 
    setFlagViewUserDetailPopup,
    generateFCMToken,
    chronoxUserRolesData, 
    setChronoxUserRolesData,
    getChronoxUserRoleApi,
    userAssignmentRoleData, 
    setUserAssignmentRoleData,
    getUserAssignmentRoleApi,
    apiRoutesPermissionAssignment, 
    setApiRoutesPermissionAssignment,
    getAPIRoutesPermissionAssignments,
    flagAddMemberPopup, 
    setFlagAddMemberPopup,
    showOrganizationPausedAlert,
    setShowOrganizationPausedAlert
  };

  return (
    <UserContext.Provider value={payload}>{children}</UserContext.Provider>
  );
};

export { UserContext, UserProvider };
